// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface PenaltySearchDTO { 
  id: string | null;
  penaltyId: number;
  name: string | null;
  city: string | null;
  state: string | null;
}
const PenaltySearchDTO = {
  create: (initValues?: Partial<PenaltySearchDTO> | Record<string, unknown> | null) => {
    return Object.assign(
    {
      id: "00000000-0000-0000-0000-000000000000",
      penaltyId: 0,
      name: "",
      city: "",
      state: "",
    },
    initValues);
  }
};

export default PenaltySearchDTO;